import { templateActionTypes, userActionTypes } from '../actions/types';
import { templateService } from '../services';
import _ from 'lodash';

const resetState = () => {
  return dispatch => dispatch({ type: templateActionTypes.RESET_STATE });
};

const search = (query, clear, tag) => {
  return (dispatch, getState) => {
    dispatch(request(tag));

    let skip=0;
    let limit=0;

    if (tag) {
      skip = getState().template[`${tag}Skip`];
      limit = 15; // getState().template[`${tag}Skip`];
    } else {
      skip = getState().template.templateSkip;
      limit = getState().template.templateLimit;
    }

    query = _.omitBy(query, value => _.isNil(value) || (_.isString(value) && _.isEmpty(value)));

    if (clear || skip === null || Number.isNaN(skip)) {
      skip = 0;
    } else {
      skip = skip + limit;
    }

    templateService
      .findAll({
        ...query,
        skip: parseInt(query.skip || skip || 0),
        limit: parseInt(query.limit || limit || 0),
      })
      .then(
        templates => {
          if (typeof templates === 'number') {

          } else if (_.has(templates, '[0].templates')) {
            templates = templates.map(templateGroup => {
              templateGroup.templates = templateGroup.templates.map((template, index) => {
                return {
                  src: `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template._id}/thumbnail.png`,
                  width: _.get(template, 'size.width', 1080),
                  height: _.get(template, 'size.height', 1080),
                  key: index.toString(),
                  type: 'Template',
                  data: {
                    index,
                    id: template._id,
                    name: template.name,
                    tags: template.tags,
                    categories: template.categories,
                    size: template.size,
                    pages: template.pages || [],
                    tempId: template.tempId,
                    price: template.price,
                    invisible: template.invisible,
                    createdAt: template.createdAt,
                    updatedAt: template.updatedAt,
                  },
                };
              });
              return templateGroup;
            });
          } else {
            const offset = clear ? 0 : _.get(getState().template.templates, 'length', 0);
            templates = templates.map((template, index) => {
              return {
                src: `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template._id}/thumbnail.png`,
                width: template.size ? template.size.width : 1080,
                height: template.size ? template.size.height : 1080,
                key: (offset + index).toString(),
                type: 'Template',
                data: {
                  index: (offset + index).toString(),
                  id: template._id,
                  name: template.name,
                  tags: template.tags,
                  categories: template.categories,
                  size: template.size,
                  pages: template.pages || [],
                  tempId: template.tempId,
                  price: template.price,
                  invisible: template.invisible,
                  createdAt: template.createdAt,
                  updatedAt: template.updatedAt,
                },
              };
            });
          }
          dispatch(success(templates, skip, limit, clear, tag));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              templateActionTypes.SEARCH_FAILURE,
              getState().authentication.pendingRefreshingToken,
              tag,
            ),
          );
        },
      );
  };

  function request(tag) {
    return { type: templateActionTypes.SEARCH_REQUEST, tag };
  }
  function success(templates, skip, limit, clear, tag) {
    return { type: templateActionTypes.SEARCH_SUCCESS, templates, skip, limit, clear, tag };
  }
};

const selectTemplate = templateId => {
  return { type: templateActionTypes.SELECT_TEMPLATE, templateId };
};

const getById = templateId => {
  return (dispatch, getState) => {
    dispatch(request());

    templateService
      .getById(templateId).then(
        template => {
          dispatch(success(template));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              templateActionTypes.FETCH_FAILURE,
              getState().authentication.pendingRefreshingToken,
            ),
          );
        },
      );
  };

  function request() {
    return { type: templateActionTypes.FETCH_REQUEST };
  }
  function success(template) {
    return { type: templateActionTypes.FETCH_SUCCESS, template };
  }
};

const update = (id, templateObj) => {
  return (dispatch, getState) => {
    dispatch(request());

    templateService
      .update({ id, ...templateObj }).then(
        templateDoc => {
          const template = templateDoc._doc || templateDoc;
          const updatedTemplate = {
            src: `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template._id}/thumbnail.png`,
            width: template.size ? template.size.width : 1080,
            height: template.size ? template.size.height : 1080,
            type: 'Template',
            data: {
              id: template._id,
              name: template.name,
              tags: template.tags,
              categories: template.categories,
              size: template.size,
              pages: template.pages || [],
              tempId: template.tempId,
              price: template.price,
              invisible: template.invisible,
              createdAt: template.createdAt,
              updatedAt: template.updatedAt,
            },
          }
          dispatch(success(updatedTemplate));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              templateActionTypes.UPDATE_FAILURE,
              getState().authentication.pendingRefreshingToken,
            ),
          );
        },
      );
  };

  function request() {
    return { type: templateActionTypes.UPDATE_REQUEST };
  }
  function success(template) {
    return { type: templateActionTypes.UPDATE_SUCCESS, template };
  }
};

const create = (templateObj) => {
  return (dispatch, getState) => {
    dispatch(request());

    templateService
      .create(templateObj).then(
        templateId => {
          dispatch(success(templateId));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              templateActionTypes.CREATE_FAILURE,
              getState().authentication.pendingRefreshingToken,
            ),
          );
        },
      );
  };

  function request() {
    return { type: templateActionTypes.CREATE_REQUEST };
  }
  function success(templateId) {
    return { type: templateActionTypes.CREATE_SUCCESS, templateId };
  }
};

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken, tag) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error, tag };
  }
};

export const templateActions = {
  resetState,
  search,
  selectTemplate,
  getById,
  update,
  create,
};
